type SectionHeadProps = {
  num: string;
  kicker: string;
  title: string;
  sub?: string;
};

const SectionHead = ({ num, kicker, title, sub }: SectionHeadProps) => (
  <div className="sec-head">
    <div className="sec-eyebrow">
      <span className="sec-num">{num}</span>
      <span className="sec-kicker">{kicker}</span>
    </div>
    <h2 className="sec-title">{title}</h2>
    {sub && <p className="sec-sub">{sub}</p>}
  </div>
);

export default SectionHead;
